import * as React from 'react';

import BasicsForm from './BasicsForm';
import Utils from '../../../common/utils';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	questionnaire: any;
	hwTable: HeightWeight[];
	actions: any;
	history: any;
	match: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	onQuestionnaireNumberKeyUp: (e: any) => void;
	onQuestionnairePaste: (e: any) => void;
	className?: string;
}
class BasicsPage extends React.Component<Props> {
	onQuestionnaireHeightWeightBlur = (e: any) => {
		this.props.onQuestionnaireBlur(e)
			.then(() => {
				const height = Utils.getHeightInInches(
					this.props.questionnaire.height,
					this.props.questionnaire.heightUnit,
					this.props.questionnaire.heightft
				);
				if (height === NaN) { return; }

				let heightWeight = this.props.hwTable.find(hw => hw.heightIn === height);
				if (heightWeight === undefined) {
					let minHeightIn = Number.POSITIVE_INFINITY;
					let maxHeightIn = Number.NEGATIVE_INFINITY;
					this.props.hwTable.forEach(hw => {
						if (minHeightIn > hw.heightIn!) {
							minHeightIn = hw.heightIn!;
						}
						if (maxHeightIn < hw.heightIn!) {
							maxHeightIn = hw.heightIn!;
						}
					});

					if (height < minHeightIn) {
						heightWeight = this.props.hwTable.find(hw => hw.heightIn === minHeightIn);
					} else if (height > maxHeightIn) {
						heightWeight = this.props.hwTable.find(hw => hw.heightIn === maxHeightIn);
					} else {
						return;
					}
				}

				const maxWeightLoss = this.props.questionnaire.weightUnit === 'lbs'
					? heightWeight!.maxWeightLossLb
					: heightWeight!.maxWeightLossKg;
				const questionnaire = {
					...this.props.questionnaire,
					maxWeightLoss: maxWeightLoss
				};

				return this.props.actions.setQuestionnaire(questionnaire);
			});
	}

	save = () => {
		return this.props.actions.saveUser(this.props.user)
		.then(() => {
			const customerDetails: CustomerDemographicDetails = {
				...this.props.customerDetails,
				customerId: this.props.user.id
			};
			return this.props.actions.saveCustomerDetails(customerDetails);
		});
	}

	back = () => {
		this.save().then(() =>
			this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/my-pledge`)
		);
	}

	next = () => {		
		this.props.actions.setQuestionnaireNavigationEnabled(false);
		this.save()
		.then(() => {
			this.props.actions.setQuestionnaireNavigationEnabled(true);
			this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/lifestyle`);
		});
	}

	render() {
		return (
			<BasicsForm
				{...this.props}
				onQuestionnaireHeightWeightBlur={this.onQuestionnaireHeightWeightBlur}
				onQuestionnairePaste={this.props.onQuestionnairePaste}
				parentNext={this.next}
				parentPrev={this.back}
			/>
		);
	}
}
export default BasicsPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/BasicsPage.tsx